/** Sidebar nav item label styles — testable without MUI render tree */

export const panelSidebarNavItemLabelSx = {
  flex: 1,
  minWidth: 0,
  fontSize: "0.875rem",
  letterSpacing: -0.1,
  lineHeight: 1.35,
  whiteSpace: "normal",
  overflowWrap: "break-word",
  wordBreak: "break-word",
};
